import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  defaultLabel: {
    description: 'countryDropdown.defaultLabel',
    defaultMessage: 'Country',
    id: 'zaNvNc',
  },
  defaultTitle: {
    description: 'countryDropdown.defaultTitle',
    defaultMessage: 'Select a Country',
    id: 'SdVnaN',
  },
});
